"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _OperationId = require("./OperationId");
Object.keys(_OperationId).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OperationId[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OperationId[key];
    }
  });
});
